module.exports = __webpack_public_path__ + "cement/img/result.92b62920.png";